import { render } from "./PrescribingQuestionnaire.vue?vue&type=template&id=c0ce3fc6"
import script from "./PrescribingQuestionnaire.vue?vue&type=script&lang=js"
export * from "./PrescribingQuestionnaire.vue?vue&type=script&lang=js"

import "./PrescribingQuestionnaire.vue?vue&type=style&index=0&id=c0ce3fc6&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__